import { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { siteConfig } from '@/mocks/siteConfig';

const articleImages: Record<string, string> = {
  'jia-ju-fengshui-rumen': 'https://readdy.ai/api/search-image?query=Bright%20modern%20Chinese%20living%20room%20with%20Feng%20Shui%20elements%2C%20lucky%20bamboo%20plant%2C%20warm%20sunlight%2C%20harmonious%20decor%2C%20cream%20walls%2C%20editorial%20interior&width=400&height=300&seq=cat-jia-ju-fengshui-rumen&orientation=landscape',
  'bangongshi-fengshui-buju': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20desk%20with%20lucky%20bamboo%20plant%2C%20warm%20natural%20light%2C%20professional%20workspace%2C%20cream%20walls&width=400&height=300&seq=cat-bangongshi-fengshui-buju&orientation=landscape',
  'caiwei-xuanzhi-jueqiao': 'https://readdy.ai/api/search-image?query=Chinese%20living%20room%20corner%20with%20money%20tree%20plant%20and%20golden%20decorations%2C%20warm%20soft%20lighting&width=400&height=300&seq=cat-caiwei-xuanzhi-jueqiao&orientation=landscape',
  'chuansha-tang-huajie': 'https://readdy.ai/api/search-image?query=Chinese%20style%20entryway%20with%20wooden%20folding%20screen%2C%20warm%20lighting%2C%20elegant%20minimal&width=400&height=300&seq=cat-chuansha-tang-huajie&orientation=landscape',
  'wuxing-yanse-fengshui': 'https://readdy.ai/api/search-image?query=Harmonious%20color%20palette%20with%20five%20Chinese%20element%20colors%2C%20warm%20lighting%2C%20minimal&width=400&height=300&seq=cat-wuxing-yanse-fengshui&orientation=landscape',
  'shuijing-nengliang-zhinan': 'https://readdy.ai/api/search-image?query=Beautiful%20collection%20of%20natural%20crystals%20citrine%20amethyst%20rose%20quartz%2C%20soft%20warm%20lighting&width=400&height=300&seq=cat-shuijing-nengliang-zhinan&orientation=landscape',
  'shengxiao-peishi-xuanze': 'https://readdy.ai/api/search-image?query=Twelve%20Chinese%20zodiac%20animal%20charms%20in%20jade%20and%20gold%2C%20warm%20soft%20lighting&width=400&height=300&seq=cat-shengxiao-peishi-xuanze&orientation=landscape',
  'yushi-yu-shuijing-qubie': 'https://readdy.ai/api/search-image?query=Chinese%20jade%20bangle%20and%20clear%20quartz%20crystal%20side%20by%20side%2C%20natural%20warm%20lighting&width=400&height=300&seq=cat-yushi-yu-shuijing-qubie&orientation=landscape',
  'chushe-peidai-jiangjiu': 'https://readdy.ai/api/search-image?query=New%20crystal%20bracelet%20held%20in%20hands%20with%20moonlight%2C%20soft%20mystical%20atmosphere&width=400&height=300&seq=cat-chushe-peidai-jiangjiu&orientation=landscape',
  'bazi-rumen-jiaocheng': 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20BaZi%20fortune%20telling%20chart%20with%20traditional%20characters%2C%20warm%20amber%20lighting&width=400&height=300&seq=cat-bazi-rumen-jiaocheng&orientation=landscape',
  'shengxiao-2026-yunshi': 'https://readdy.ai/api/search-image?query=Twelve%20Chinese%20zodiac%20animals%20illustrated%20in%20traditional%20ink%20style%2C%20minimal%20elegant&width=400&height=300&seq=cat-shengxiao-2026-yunshi&orientation=landscape',
  'ziwei-doushu-jichu': 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20ZiWei%20DouShu%20star%20chart%20with%20twelve%20palaces%2C%20warm%20lighting&width=400&height=300&seq=cat-ziwei-doushu-jichu&orientation=landscape',
  'mianxiang-xue-rumen': 'https://readdy.ai/api/search-image?query=Artistic%20illustration%20of%20Chinese%20face%20reading%20diagram%2C%20minimal%20ink%20style&width=400&height=300&seq=cat-mianxiang-xue-rumen&orientation=landscape',
  'meiri-xingyunse': 'https://readdy.ai/api/search-image?query=Fashionable%20color%20wheel%20with%20five%20element%20Chinese%20color%20theory%2C%20minimal%20elegant&width=400&height=300&seq=cat-meiri-xingyunse&orientation=landscape',
  'jiemian-xingyunse': 'https://readdy.ai/api/search-image?query=Twelve%20zodiac%20signs%20with%20corresponding%20color%20palettes%2C%20minimal%20design&width=400&height=300&seq=cat-jiemian-xingyunse&orientation=landscape',
  'siji-xingyunse': 'https://readdy.ai/api/search-image?query=Four%20seasonal%20fashion%20color%20palettes%20with%20Chinese%20aesthetic%2C%20minimal&width=400&height=300&seq=cat-siji-xingyunse&orientation=landscape',
  'keting-buju-jueqiao': 'https://readdy.ai/api/search-image?query=Bright%20modern%20Chinese%20style%20living%20room%20with%20lucky%20elements%2C%20warm%20sunlight&width=400&height=300&seq=cat-keting-buju-jueqiao&orientation=landscape',
  'banggongzhuo-zhengli': 'https://readdy.ai/api/search-image?query=Clean%20organized%20modern%20office%20desk%20with%20small%20lucky%20bamboo%20plant%2C%20warm%20lighting&width=400&height=300&seq=cat-banggongzhuo-zhengli&orientation=landscape',
  'wofa-buju-yeshen': 'https://readdy.ai/api/search-image?query=Peaceful%20minimalist%20bedroom%20with%20bed%20against%20wall%2C%20soft%20warm%20lighting&width=400&height=300&seq=cat-wofa-buju-yeshen&orientation=landscape',
  'top10-kaiyun-wupin': 'https://readdy.ai/api/search-image?query=Collection%20of%20Chinese%20lucky%20items%20fortune%20cat%20crystal%20bracelet%20jade%2C%20warm%20lighting&width=400&height=300&seq=cat-top10-kaiyun-wupin&orientation=landscape',
  'jiache-kaiyun-wu': 'https://readdy.ai/api/search-image?query=Car%20interior%20with%20small%20Chinese%20lucky%20charms%20hanging%2C%20warm%20sunlight&width=400&height=300&seq=cat-jiache-kaiyun-wu&orientation=landscape',
  'songli-kaiyun-liwu': 'https://readdy.ai/api/search-image?query=Beautifully%20wrapped%20Chinese%20lucky%20gifts%20with%20red%20ribbon%2C%20warm%20soft%20lighting&width=400&height=300&seq=cat-songli-kaiyun-liwu&orientation=landscape',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const [activeSlug, setActiveSlug] = useState(slug || 'fengshui');

  useEffect(() => {
    if (slug) setActiveSlug(slug);
  }, [slug]);

  const currentCategory = categories.find((c) => c.slug === activeSlug);
  const categoryArticles = articles.filter((a) => a.category === activeSlug);

  if (!currentCategory) {
    return (
      <div className="min-h-screen flex items-center justify-center pt-16">
        <p className="text-foreground-500">分类未找到</p>
      </div>
    );
  }

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: `${currentCategory.name} - ${siteConfig.name}`,
            description: currentCategory.description,
            url: `${siteConfig.url}category/${activeSlug}`,
            isPartOf: {
              '@type': 'WebSite',
              name: siteConfig.name,
              url: siteConfig.url,
            },
          }),
        }}
      />

      <main className="min-h-screen pt-16">
        <div className="bg-background-100 border-b border-background-200">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: currentCategory.name },
              ]}
            />
            <div className="flex items-center gap-4 mt-2">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className={`${currentCategory.icon} text-2xl`}></i>
              </div>
              <div>
                <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                  {currentCategory.name}
                </h1>
                <p className="text-sm text-foreground-500 mt-1 max-w-xl">
                  {currentCategory.description}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
          <div className="flex flex-wrap items-center gap-2 mb-8">
            <span className="text-sm text-foreground-500 mr-2">分类切换：</span>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-1 py-1 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                  activeSlug === cat.slug
                    ? 'px-4 bg-primary-500 text-background-50'
                    : 'px-4 bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {categoryArticles.map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer flex flex-col"
              >
                <div className="w-full h-48 flex-shrink-0">
                  <img
                    src={articleImages[article.slug] || 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20auspicious%20elements%2C%20minimal%20style%2C%20cream%20background&width=400&height=300&seq=category-fallback&orientation=landscape'}
                    alt={article.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-4 flex-1 flex flex-col justify-between">
                  <div>
                    <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                      {article.excerpt}
                    </p>
                  </div>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-user-line"></i>
                      {article.author}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {article.readTime}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {categoryArticles.length === 0 && (
            <div className="text-center py-20">
              <p className="text-foreground-500">该分类暂无文章</p>
            </div>
          )}
        </div>
      </main>
    </>
  );
}